import React, { useEffect, useState } from 'react';
import classnames from 'classnames/bind';
import { Fade } from 'react-awesome-reveal';
import { Button } from '../../Button';
import { Logo } from '../../Logo';
import { GameProgressBar } from '../GameProgressBar';
import { Indicator } from '../Indicator';
import { PrelandCardSelector } from '../PrelandCardSelector';
import CustomModal from '../../Modal';
import previewCardImageSrc from '../../../assets/images/prelander/dummy-card.png';
import decorImageSrc from '../../../assets/images/prelander/decor.png';
import crownImageSrc from '../../../assets/images/prelander/crown.png';
import questionImageSrc from '../../../assets/images/prelander/question-modal.png';
import buddaImageSrc from '../../../assets/images/prelander/budda-modal.png';
import statistics1ImageSrc from '../../../assets/images/prelander/statistics-1.png';
import statistics2ImageSrc from '../../../assets/images/prelander/statistics-2.png';
import statistics3ImageSrc from '../../../assets/images/prelander/statistics-3.png';
import bronzeWinnerImageSrc from '../../../assets/images/prelander/bronze-winner.png';
import { isMobile } from '../../../lib/shared/dimensions';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import styles from './BronzeStage.css';


const cx = classnames.bind(styles);

const PREVIEW_CARDS = [
    {
        imageUrl: previewCardImageSrc,
        id: 1,
        isActive: true,
    },
    {
        imageUrl: previewCardImageSrc,
        id: 2
    },
    {
        imageUrl: previewCardImageSrc,
        id: 3
    },
    {
        imageUrl: previewCardImageSrc,
        id: 4
    },
    {
        imageUrl: previewCardImageSrc,
        id: 5
    }
];

const STATISTICS_LIST = [
    {
        id: 1,
        imageUrl: statistics1ImageSrc,
        description: '65% of our users are experiencing the same thing.'
    },
    {
        id: 2,
        imageUrl: statistics2ImageSrc,
        description: 'The solution? Keep playing.'
    },
    {
        id: 3,
        imageUrl: statistics3ImageSrc,
        description: 'Gain experience and knowledge, win battles with real people!'
    }
];

const MAX_NUMBER_OF_CARDS = 9;

const WELCOME_MODAL = 'welcomeModal';
const PRE_FINISH_MODAL = 'preFinishModal';
const GAME_STATISTICS_MODAL = 'gameStatisticsModal';
const SECOND_PLAYER_INDEX = 1;
const FIRST_PLAYER_INDEX = 0

function BronzeStage({initialCards, finishStage, selectedCards, selectCard, teamPowerScore}) {
    const [isPreview, setIsPreview] = useState(true);
    const [isFinish, setIsFinish] = useState(false);
    const [modal, setModal] = useState({type: ''});
    const [cards, setCards] = useState(initialCards);
    const [isAnimateModalContent, setIsAnimateModalContent] = useState(false);

    useEffect(() => {
        if (isPreview) {
            logEvent(EVENT_TYPES.SWIPE_PRACTICE_SCREEN_VISITED);
        }
    
        if (selectedCards.length === FIRST_PLAYER_INDEX && !isPreview) {
            logEvent(EVENT_TYPES.FIRST_PLAYER_VISITED);
        }

        if (selectedCards.length === SECOND_PLAYER_INDEX && !isPreview) {
            logEvent(EVENT_TYPES.SECOND_PLAYER_VISITED);
            logEvent(EVENT_TYPES.SECOND_PLAYER_PAGEVIEW);
        }
    }, [selectedCards.length, isPreview]);

    useEffect(() => {
        if (modal.type === WELCOME_MODAL) {
            logEvent(EVENT_TYPES.PICK_BEST_PLAYERS_SCREEN_VISITED);
        }
    }, [modal.type]);

    const handleStart = () => {
        setTimeout(() => {
            setModal({type: WELCOME_MODAL});
        }, 250);

        setTimeout(() => {
            setIsAnimateModalContent(true);
        }, 300);

        setTimeout(() => {
            setIsAnimateModalContent(false);
        }, 2500);

        setTimeout(() => {
            setModal({});
            setIsPreview(false);
        }, 3000);
    };

    const handleFinish = () => {
        setIsAnimateModalContent(false);

        setTimeout(() => {
            setModal({type: ''});
            setIsPreview(false);
            setIsFinish(true);
        }, 500);
    };

    const openGameStaticticsModal = () => {
        setIsAnimateModalContent(false);

        setTimeout(() => {
            setModal({type: GAME_STATISTICS_MODAL});
        }, 500);

        setTimeout(() => {
            setIsAnimateModalContent(true);
        }, 600);
    };

    const onSelectCard = ({card, isSelected}) => {
        if (isSelected) {
            if (selectedCards.length + 1 === MAX_NUMBER_OF_CARDS) {
                setTimeout(() => {
                    setModal({type: PRE_FINISH_MODAL});

                    setTimeout(() => {
                        setIsAnimateModalContent(true);
                    }, 0);
                }, 1000);
            }

            selectCard(card);
        };
    
        setCards(prevState => {
            const [currentCard, nextCard, ...otherCards] = prevState;

            return [
                nextCard,
                ...otherCards,
                ...(!isSelected ? [{...currentCard, id: Math.random()}] : [])
            ]
        });
    };

    const renderContent = () => {
        if (isPreview) {
            return (
                <Fade
                    duration={500}
                    className={cx('content', 'preview')}
                    triggerOnce
                >
                    <>
                        <header className={styles.header}>
                            <Logo className={styles.logo}/>
                            <p className={styles.previewTitle}>
                                FREE-TO-PLAY FANTASY GAME FOR COUNTER-STRIKE 2™
                            </p>
                        </header>
                        <PrelandCardSelector
                            cards={PREVIEW_CARDS}
                            onCardLeftScreen={handleStart}
                            isDisabled={false}
                            withTeamRoleScore={false}
                            key='preview-cards'
                        />
                        <footer className={styles.footer}>
                            <img
                                src={decorImageSrc}
                                alt='decor'
                                className={cx('imageDecor', 'top', 'onlyDesktop')}
                            />
                            <div className={styles.footerWrapper}>
                                <div className={styles.previewTextWithButton}>
                                    <Button
                                        iconLeft={{type: 'close'}}
                                        className={styles.buttonClose}
                                        type='tertiary'
                                    />
                                    <span className={styles.previewText}>Tap / swipe left to skip</span>
                                </div>
                                <span className={styles.previewText}>Or</span>
                                <div className={styles.previewTextWithButton}>
                                    <Button
                                        iconLeft={{type: 'checked'}}
                                        className={styles.buttonCheck}
                                        type='tertiary'
                                    />
                                    <span className={styles.previewText}>Tap / swipe right to skip</span>
                                </div>
                            </div>
                            <img
                                src={decorImageSrc}
                                alt='decor'
                                className={cx('imageDecor', 'bottom', 'onlyDesktop')}
                            />
                        </footer>
                    </>
                </Fade>
            )
        };

        if (isFinish) {
            return (
                <Fade
                    duration={500}
                    className={cx('content', 'finish')}
                    triggerOnce
                >
                    <>
                        <GameProgressBar
                            progressList={[100, 0, 0]}
                        />
                        <div className={styles.wrapper}>
                            <img
                                src={`${bronzeWinnerImageSrc}?v=2`}
                                alt='bronze'
                                className={styles.imageWinner}
                            />
                        </div>
                        <div className={styles.footerFinish}>
                            <Button
                                label='Continue'
                                onClick={finishStage}
                                className={styles.fullButton}
                            />
                        </div>
                    </>
                </Fade>
            );
        }

        const isDisabled = selectedCards.length >= MAX_NUMBER_OF_CARDS;

        return (
            <Fade
                duration={500}
                className={cx('content', 'contentWithFlex')}
                triggerOnce
            >
                <>
                    <div>
                        <GameProgressBar
                            progressList={[selectedCards.length / MAX_NUMBER_OF_CARDS * 100 || 5, 0, 0]}
                        />
                        <div className={styles.counterInformation}>
                            <p className={styles.counterInformationLabel}>Cards selected</p>
                            <p className={styles.counterInformationValue}>{selectedCards.length} of {MAX_NUMBER_OF_CARDS}</p>
                        </div>
                    </div>
                    <PrelandCardSelector
                        cards={cards}
                        onSelectCard={onSelectCard}
                        isDisabled={isDisabled}
                        key='cards'
                    />
                    <div className={styles.teamPower}>
                        <p className={styles.teamPowerTitle}>Your team power</p>
                        <Indicator
                            value={teamPowerScore || (isMobile() ? 3 : 1.5)}
                            incValue={cards[0].teamRoleScore}
                            height={8}
                        />
                    </div>
                </>
            </Fade>
        );
    };

    return (
        <>
            {renderContent()}
            <CustomModal
                isOpen={modal.type === WELCOME_MODAL}
                onCloseModal={() => {}}
                overlayClassName={styles.overlay}
                className={styles.modal}
            >
                <img
                    src={crownImageSrc}
                    alt='crown'
                    className={cx('modalImage', {withAnimation: isAnimateModalContent})}
                />
                <div className={cx('modalWrapper', {withAnimation: isAnimateModalContent})}>
                    <img
                        src={decorImageSrc}
                        alt='decor'
                        className={cx('imageDecor', 'top')}
                    />
                    <span className={cx('modalText', 'modalTextUppercase')}>
                        PICK THE 9 BEST PLAYERS FROM THE GIVEN LIST <br /><br />
                        You can always go back to the cards you skipped
                    </span>
                    <img
                        src={decorImageSrc}
                        alt='decor'
                        className={cx('imageDecor', 'bottom')}
                    />
                </div>
                <div className={styles.modalImage} />
            </CustomModal>
            <CustomModal
                isOpen={modal.type === PRE_FINISH_MODAL}
                onCloseModal={() => {}}
                overlayClassName={styles.overlay}
                className={styles.modal}
            >
                <img
                    src={questionImageSrc}
                    alt='question'
                    className={cx('modalImage', {withAnimation: isAnimateModalContent})}
                />
                <div className={cx('modalWrapper', {withAnimation: isAnimateModalContent})}>
                    <img
                        src={decorImageSrc}
                        alt='decor'
                        className={cx('imageDecor', 'top')}
                    />
                    <span className={styles.modalText}>Are you confident in your choice of strong players for your team?</span>
                    <img
                        src={decorImageSrc}
                        alt='decor'
                        className={cx('imageDecor', 'bottom')}
                    />
                </div>
                <div className={styles.modalImage} />
                <div className={cx('modalFooter', 'withChildren')}>
                    <Button
                        label='Yes!'
                        onClick={handleFinish}
                        type='secondary'
                        className={styles.secondaryButton}
                    />
                    <Button
                        label='Not sure'
                        onClick={openGameStaticticsModal}
                        type='secondary'
                        className={styles.secondaryButton}
                    />
                </div>
            </CustomModal>
            <CustomModal
                isOpen={modal.type === GAME_STATISTICS_MODAL}
                onCloseModal={() => {}}
                overlayClassName={styles.overlay}
                className={styles.modal}
            >
                <img
                    src={buddaImageSrc}
                    alt='budda'
                    className={cx('modalImage', {withAnimation: isAnimateModalContent})}
                /> 
                <div className={cx('modalWrapper', {withAnimation: isAnimateModalContent})}>
                    <img
                        src={decorImageSrc}
                        alt='decor'
                        className={cx('imageDecor', 'top')}
                    />
                    <span className={cx('modalText', 'modalTextUppercase')}>You are not alone!</span>
                    <div className={styles.statisticsList}>
                        {STATISTICS_LIST.map(item => (
                            <div
                                className={styles.statisticsListItem}
                                key={item.id}
                            >
                                <img
                                    src={item.imageUrl}
                                    alt='statistics'
                                    className={styles.statisticsListItemImage}
                                />
                                <span className={styles.statisticsListItemDescription}>{item.description}</span>
                            </div>
                        ))}
                    </div>
                    <img
                        src={decorImageSrc}
                        alt='decor'
                        className={cx('imageDecor', 'bottom')}
                    />
                </div>
                <div className={styles.modalImage} />
                <div className={styles.modalFooter}>
                    <Button
                        label='Continue'
                        onClick={handleFinish}
                        className={styles.fullButton}
                    />
                </div>
            </CustomModal>
        </>
    )
}

export {
    BronzeStage
}
